export default {
  tableTitle: {
    id: 'seller_options_integrations_list_table_title',
    defaultMessage: 'Integrations',
  },
  name: {
    id: 'seller_options_integrations_list_name',
    defaultMessage: 'Name',
  },
  status: {
    id: 'seller_options_integrations_list_status',
    defaultMessage: 'Status',
  },
  date: {
    id: 'seller_options_integrations_list_date',
    defaultMessage: 'Date',
  },
  token: {
    id: 'seller_options_integrations_list_token',
    defaultMessage: 'Token',
  },
  accessTokenViaPassword: {
    id: 'seller_options_integrations_list_access_token_via_password',
    defaultMessage: 'Access token via password',
  },
  recoverToken: {
    id: 'seller_options_integrations_list_recover_token',
    defaultMessage: 'Recover token',
  },
  copyToClipboard: {
    id: 'seller_options_integrations_list_copy_to_clipboard',
    defaultMessage: 'Copy to clipboard',
  },
  password: {
    id: 'seller_options_integrations_list_password',
    defaultMessage: 'Password',
  },
  delete: {
    id: 'seller_options_integrations_list_delete',
    defaultMessage: 'Delete',
  },
  deleteConfirmationMessage: {
    id: 'seller_options_integrations_list_delete_confirmation_message',
    defaultMessage: 'Do you really want to delete this integrator?',
  },
  confirmDelete: {
    id: 'seller_options_integrations_list_delete_confirmation_yes',
    defaultMessage: 'Yes, delete it',
  },
  cancelDelete: {
    id: 'seller_options_integrations_list_delete_confirmation_no',
    defaultMessage: 'No, keep it',
  },
}
